// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import {useCallback, useEffect, useState} from 'react';
import ReactPlayer from 'react-player';

import {FileInfo} from 'mattermost-redux/types/files';

import FileInfoPreview from 'components/file_info_preview';

import Constants from 'utils/constants';
import {reportErrorToSentry} from 'utils/sentry';

type Props = {
    fileInfo: FileInfo;
    fileUrl: string;
    isMobileView: boolean;
};

const AudioVideoPreview: React.FC<Props> = ({fileInfo, fileUrl, isMobileView}) => {
    const [canPlay, setCanPlay] = useState(true);

    let width: number = Constants.WEB_VIDEO_WIDTH;
    let height: number = Constants.WEB_VIDEO_HEIGHT;

    if (isMobileView) {
        width = Constants.MOBILE_VIDEO_WIDTH;
        height = Constants.MOBILE_VIDEO_HEIGHT;
    }

    useEffect(() => {
        setCanPlay(true);
    }, [fileUrl]);

    const handleError = useCallback(
        (error: unknown) => {
            reportErrorToSentry({
                error,
                url: fileUrl,
            });

            setCanPlay(false);
        },
        [fileUrl],
    );

    if (!canPlay) {
        return (
            <FileInfoPreview
                fileInfo={fileInfo}
                fileUrl={fileUrl}
            />
        );
    }

    return (
        <ReactPlayer
            url={fileUrl}
            width={width}
            height={height}
            controls={true}
            data-testid='player'
            onError={handleError}
        />
    );
};

export default AudioVideoPreview;
